WiseMetering.Model.Bucket = WiseMetering.Model.extend({
    urlRoot: '/buckets',

    indicator: function() {
        return WiseMetering.indicators.get(this.get('indicator_id'));
    }
});
